import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MainNavbar } from '../../components/navigation/MainNavbar';
import enContent from '../../content/legal/en/privacy.json';
import frContent from '../../content/legal/fr/privacy.json';

export default function PrivacyPolicyPage() {
  const { i18n } = useTranslation();
  const isFr = i18n.language?.startsWith('fr');
  const content = useMemo(() => (isFr ? frContent : enContent), [isFr]);

  return (
    <div className="min-h-screen bg-gray-50">
      <MainNavbar />

      <section className="pt-32 pb-12 bg-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <p className="text-sm text-gray-500 tracking-[0.4em] uppercase">
            {content.title}
          </p>
          <h1 className="text-4xl font-black text-gray-900 mt-2 mb-4">
            {content.sections?.[0]?.title || content.title}
          </h1>
          <p className="text-sm text-gray-500">
            {content.effectiveDate}{' '}
            <a
              href="mailto:contact@flexygroup.ca"
              className="text-yellow-600 font-semibold"
            >
              contact@flexygroup.ca
            </a>
            .
          </p>
        </div>
      </section>

      <main className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-12 space-y-8">
        {content.sections?.map((section, idx) => (
          <section
            key={idx}
            className="rounded-3xl bg-white shadow-lg border border-gray-100 p-6 space-y-4"
          >
            <h2 className="text-2xl font-black text-gray-900">{section.title}</h2>
            <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
              {section.paragraphs?.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              {section.items && (
                <ul className="list-disc pl-6 space-y-2">
                  {section.items.map((item, i) =>
                    Array.isArray(item) ? (
                      <li key={i}>
                        <strong>{item[0]}: </strong>
                        {item[1]}
                      </li>
                    ) : (
                      <li key={i}>{item}</li>
                    ),
                  )}
                </ul>
              )}
              {section.subsections?.map((sub, si) => (
                <div key={si} className="space-y-2">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {sub.title}
                  </h3>
                  {sub.paragraphs?.map((p, pi) => (
                    <p key={pi}>{p}</p>
                  ))}
                  {sub.items && (
                    <ul className="list-disc pl-6 space-y-2">
                      {sub.items.map((item, ii) => (
                        <li key={ii}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}
